import { api } from "./api";

export const LiderancaService = {

  async findAll() {
    const response = await api.get("/liderancas");
    const data = response.data;
    if (Array.isArray(data)) {
      return data;
    }
    if (Array.isArray(data?.data)) {
      return data.data;
    }
    return [];
  },

  async create(
    data: any
  ) {

    const response =
      await api.post(
        "/liderancas",
        data
      );

    return response.data;
  },

  async update(
    id: number,
    data: any
  ) {

    const response =
      await api.put(
        `/liderancas/${id}`,
        data
      );

    return response.data;
  },

  async delete(
    id: number
  ) {

    const response =
      await api.delete(
        `/liderancas/${id}`
      );

      console.log("LiderancaService.delete response:", response);

    return response.data;
  }
};